<template>
	<!-- 产品中心 有用到 -->
	<div class="comp">
		<el-upload   ref='upload' action="action" :on-preview="handlePreview" :on-remove="handleRemove"
		multiple :limit="num" :on-exceed="handleExceed" :file-list="fileList" :http-request="uploadImg" list-type="picture">
			<el-button size="mini" type="warning">上传</el-button>
		</el-upload>
		<el-dialog title="预览" :visible.sync="dialogImg" width="50%" append-to-body>
			<img style="width: 100%;height: 100%;" :src="handleImg" />
			<span slot="footer" class="dialog-footer">
				<el-button type="warning" @click="dialogImg = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				dialogImg: false,
				fileList: this.fileLists,
				handleImg: '',
			}
		},
		props:{
			fileLists:{
				default:()=>{
					return []
				}
			},
			num:{
				default:5,
			},
			remark:{
				default:-1,
			}
		},
		// watch: {
		// 	fileLists: {
		// 		immediate: true,
		// 		handler(newvalue) {
		// 			this.fileList = newvalue;
		// 			this.$emit('sendImg', newvalue)
		// 		},
		// 	}
		// },
		created() {
			// this.fileList = JSON.parse(this.fileList)
		},
		methods: {
			handleRemove(file, fileList) {
				if (file.status == 'success') {
					this.fileList = fileList
					console.log(this.fileList)
					this.$emit('sendImg', this.fileList,this.remark)
				}
			},
			handlePreview(file) {
				this.dialogImg = true;
				this.handleImg = file.url;
			},
			handleExceed(files) {
				console.log(files)
				this.$message.warning('最多只能上传'+this.num+'个图片');
			},
			uploadImg(item) {
				var formData = new FormData(); //生成文件对象
				formData.append('img', item.file);
				this.$upload.uploadImg_dir(formData,{dir:'uploadImg'}).then(data => {
					if (data.timestamp) {
						this.fileList.push({
							name: data.uuid,
							url: data.url
						});
						this.$emit('sendImg', this.fileList,this.remark)
					}
				})
			},
		},
	}
</script>

<style scoped lang="scss">
	.comp{
		display: inline-block;vertical-align: top;
	}
</style>
